import { MessagesQuery } from 'src/generated/operations.ts';
import { BtuPerPoundPerFahrenheit } from 'src/utils/BtuPerPoundPerFahrenheit';
import { UnitMap } from 'uom';
import { Units } from 'uom-units';

type I18Key = keyof Omit<MessagesQuery['vssI18n'], '__typename'>;
type VssMessages = Record<I18Key, string>;

export const MESSAGES: VssMessages & {
    m_flow: 'flow';
    i_dn: 'dn';
    m_dn: 'dn';
} = {
    projectPageConfirmationModalHeader: 'projectPageConfirmationModalHeader',
    projectPageRemoveConfirmation: 'projectPageRemoveConfirmation',
    projectPageSaveSelection: 'projectPageSaveSelection',
    copyLinkToastTitle: 'copyLinkToastTitle',
    copyLinkSuccessMessage: 'copyLinkSuccessMessage',
    copyLinkErrorMessage: 'copyLinkErrorMessage',
    seq1: 'seq1',
    seq2: 'seq2',
    ValveFlowVelocityWarning: 'ValveFlowVelocityWarning',
    NarrowYourSelectionTitle: 'NarrowYourSelectionTitle',
    NarrowYourSelectionDescription: 'NarrowYourSelectionDescription',
    ActuatorAccessoriesVstWarningBody: 'ActuatorAccessoriesVstWarningBody',
    ActuatorAccessoriesVstWarningTitle: 'ActuatorAccessoriesVstWarningTitle',
    Comment: 'Comment',
    CheckoutCommentLabel: 'CheckoutCommentLabel',
    CheckoutCommentPlaceholder: 'CheckoutCommentPlaceholder',
    Selection: 'Selection',
    Actuators: 'Actuators',
    Valves: 'Valves',
    Sensors: 'Sensors',
    CV_1: 'CV_1',
    KV_1: 'KV_1',
    EffectiveDpv1: 'EffectiveDpv1',
    EffectivePV1: 'EffectivePV1',
    FlowVelocity1: 'FlowVelocity1',
    MinReqDpv1: 'MinReqDpv1',
    KV_2: 'KV_2',
    CV_2: 'CV_2',
    EffectiveDpv2: 'EffectiveDpv2',
    EffectivePV2: 'EffectivePV2',
    FlowVelocity2: 'FlowVelocity2',
    MinReqDpv2: 'MinReqDpv2',
    v100_1: 'v100_1',
    v100_2: 'v100_2',
    modalFilterAccessoriesLabel: 'modalFilterAccessoriesLabel',
    DevicePricePerUnit: 'DevicePricePerUnit',
    OperationMode: 'OperationMode',
    MeasuringRangePressure: 'MeasuringRangePressure',
    MeasuringRangePressureBar: 'MeasuringRangePressureBar',
    MeasuringRangePressurePSI: 'MeasuringRangePressurePSI',
    OutputSignalPassiveTemperature: 'OutputSignalPassiveTemperature',
    flow1: 'flow1',
    flow2: 'flow2',
    qp: 'qp',
    ActuatorHomeInfoTitle: 'ActuatorHomeInfoTitle',
    ActuatorHomeInfo1: 'ActuatorHomeInfo1',
    ActuatorHomeInfoLink: 'ActuatorHomeInfoLink',
    ActuatorHomeInfo2: 'ActuatorHomeInfo2',
    ActuatorHomeInfo3: 'ActuatorHomeInfo3',
    ActuatorHomeInfo4: 'ActuatorHomeInfo4',
    ActuatorHomeInfo5: 'ActuatorHomeInfo5',
    safetyDescription: 'safetyDescription',
    safetyVelocity: 'safetyVelocity',
    safetyCondition: 'safetyCondition',
    safetySlug: 'safetySlug',
    safetyRecommendation: 'safetyRecommendation',
    DamperHeightAm: 'DamperHeightAm',
    DamperWidthAm: 'DamperWidthAm',
    i_flow: 'flow',
    m_flow: 'flow',
    i_dn: 'dn',
    m_dn: 'dn',
    mountingType: 'mountingType',
    CableLength: 'CableLength',
    DamperRequiredTorque: 'DamperRequiredTorque',
    BladeWithSeals: 'BladeWithSeals',
    BladeWithoutSeals: 'BladeWithoutSeals',
    DamperType: 'DamperType',
    Newton: 'Newton',
    NewtonMeter: 'NewtonMeter',
    PoundForce: 'PoundForce',
    PoundInch: 'PoundInch',
    SquareMeter: 'SquareMeter',
    SquareFeet: 'SquareFeet',
    Millimeter: 'Millimeter',
    Inch: 'Inch',
    Percent: 'Percent',
    calcDiameterLabel: 'calcDiameterLabel',
    calcDiameterDescription: 'calcDiameterDescription',
    calcRectangularDescription: 'calcRectangularDescription',
    actuatorsUserInputAirflow: 'actuatorsUserInputAirflow',
    actuatorsUserInputAreaInfo: 'actuatorsUserInputAreaInfo',
    AirflowLow: 'AirflowLow',
    AirflowMid: 'AirflowMid',
    AirflowHigh: 'AirflowHigh',
    DamperRequiredForce: 'DamperRequiredForce',
    DamperCrankArmLength: 'DamperCrankArmLength',
    DamperSafetyFactor: 'DamperSafetyFactor',
    DamperHeight: 'DamperHeight',
    DamperArea: 'DamperArea',
    DamperDiameter: 'DamperDiameter',
    DamperWidth: 'DamperWidth',
    DamperRectangular: 'DamperRectangular',
    DamperRound: 'DamperRound',
    DamperBladeType: 'DamperBladeType',
    ParallelBladeWithSeals: 'ParallelBladeWithSeals',
    OpposedBladeWithSeals: 'OpposedBladeWithSeals',
    ParallelBladeWithoutSeals: 'ParallelBladeWithoutSeals',
    OpposedBladeWithoutSeals: 'OpposedBladeWithoutSeals',
    actuatorsUserInputPageTitle: 'actuatorsUserInputPageTitle',
    checkoutActuatorTitle: 'checkoutActuatorTitle',
    ActuatorsModalFilterLabel: 'ActuatorsModalFilterLabel',
    ActuatorsListAppPageTitle: 'ActuatorsListAppPageTitle',
    ActuatorParams: 'ActuatorParams',
    SelectActuatorType: 'SelectActuatorType',
    ActuatorsHomePageTypesTitle: 'ActuatorsHomePageTypesTitle',
    ActuatorsHomePageTitle: 'ActuatorsHomePageTitle',
    // actuators ^^^
    SensorMedium: 'SensorMedium',
    MeasuringRangeCO2: 'MeasuringRangeCO2',
    checkoutSensorsTitle: 'checkoutSensorsTitle',
    metricUnit: 'metricUnit',
    imperialUnit: 'imperialUnit',
    accessoriesPageSensorsTitle: 'accessoriesPageSensorsTitle',
    SensorsModalFilterLabel: 'SensorsModalFilterLabel',
    SensorsPageTitle: 'SensorsPageTitle',
    SelectedSensor: 'SelectedSensor',
    SelectSensorType: 'SelectSensorType',
    SensorsHomePageTitle: 'SensorsHomePageTitle',
    SensorsHomePageTypesTitle: 'SensorsHomePageTypesTitle',
    Description: 'Description',
    MeasuredValues: 'MeasuredValues',
    MeasuringRangeRH: 'MeasuringRangeRH',
    SensorApplication: 'SensorApplication',
    OutputSignal: 'OutputSignal',
    m_MeasuringRangeTemperature: 'm_MeasuringRangeTemperature',
    DisplayType: 'DisplayType',
    ProbeLength: 'ProbeLength',
    AdditionalFeatures: 'AdditionalFeatures',
    i_MeasuringRangeTemperature: 'i_MeasuringRangeTemperature',
    certification: 'certification',
    flow: 'flow',
    pressureAir: 'pressureAir',
    Label: 'Label',
    clipPosition: 'clipPosition',
    KV: 'KV',
    CV: 'CV',
    CreateNewCombo: 'CreateNewCombo',
    // TODO: remove productsAddedToBasket, use selectedProductsDescription instead
    productsAddedToBasket: 'productsAddedToBasket',
    accessoriesPageGateways: 'accessoriesPageGateways',
    accessoriesPageTools: 'accessoriesPageTools',
    Connection: 'Connection',
    PipeConnectors: 'PipeConnectors',
    checkoutValveAccessoriesTitle: 'checkoutValveAccessoriesTitle',
    checkoutActuatorAccessoriesTitle: 'checkoutActuatorAccessoriesTitle',
    failSafeFunction: 'failSafeFunction',
    MaxFluidTemperature: 'MaxFluidTemperature',
    MaxFluidTemperatureAm: 'MaxFluidTemperatureAm',
    PN: 'PN',
    PermissiblePressure: 'PermissiblePressure',
    ValveBody: 'ValveBody',
    bodySize: 'bodySize',
    controlType: 'controlType',
    integratedSwitch: 'integratedSwitch',
    nominalVoltage: 'nominalVoltage',
    protection: 'protection',
    runningTime: 'runningTime',
    KiloWatt: 'KiloWatt',
    BtuPerHour: 'BtuPerHour',
    Celsius: 'Celsius',
    Kelvin: 'Kelvin',
    Fahrenheit: 'Fahrenheit',
    CubicMeterPerHour: 'CubicMeterPerHour',
    LiterPerSecond: 'LiterPerSecond',
    LiterPerHour: 'LiterPerHour',
    GallonsPerMinute: 'GallonsPerMinute',
    KilogramPerHour: 'KilogramPerHour',
    PoundLbPerHour: 'PoundLbPerHour',
    KilojoulePerKilogramKelvin: 'KilojoulePerKilogramKelvin',
    BtuPerPoundPerFahrenheit: 'BtuPerPoundPerFahrenheit',
    KilogramPerCubicMeter: 'KilogramPerCubicMeter',
    PoundPerCubicFoot: 'PoundPerCubicFoot',
    KiloPascal: 'KiloPascal',
    Pascal: 'Pascal',
    psi: 'psi',
    CubicFeetPerMinute: 'CubicFeetPerMinute',
    CalcV100TitleResult: 'CalcV100TitleResult',
    CalcMassFlowTitleResult: 'CalcMassFlowTitleResult',
    CalcMaxDPTitleResult: 'CalcMaxDPTitleResult',
    CalcInletTitleResult: 'CalcInletTitleResult',
    CalcOutletTitleResult: 'CalcOutletTitleResult',
    Water: 'Water',
    Ethylene: 'Ethylene',
    Propylene: 'Propylene',
    Other: 'Other',
    Reset: 'Reset',
    WE_RE_SORRY: 'WE_RE_SORRY',
    FLUID_TEMPERATURE: 'FLUID_TEMPERATURE',
    CANCEL: 'CANCEL',
    yes: 'yes',
    no: 'no',
    VIEW_MORE: 'VIEW_MORE',
    VIEW_LESS: 'VIEW_LESS',
    hide: 'hide',
    // brand new
    ErrorSteamRatioHigh: 'ErrorSteamRatioHigh',
    ErrorSteamInletHigh: 'ErrorSteamInletHigh',
    ErrorSteamOutletHigh: 'ErrorSteamOutletHigh',
    next: 'next',
    back: 'back',
    loading: 'loading',
    FlowCalcSequence1: 'FlowCalcSequence1',
    FlowCalcSequence2: 'FlowCalcSequence2',
    v100: 'v100',
    maxDp: 'maxDp',
    PreferredActuators: 'PreferredActuators',
    AllActuators: 'AllActuators',
    ManualOperation: 'ManualOperation',
    MinReqDpv: 'MinReqDpv',
    EffectiveDpv: 'EffectiveDpv',
    EffectivePV: 'EffectivePV',
    FlowVelocity: 'FlowVelocity',
    checkout: 'checkout',
    mountedOrUnmounted: 'mountedOrUnmounted',
    CalcV100Title: 'CalcV100Title',
    CalcV100TitleDescr: 'CalcV100TitleDescr',
    CalcMaxDPTitle: 'CalcMaxDPTitle',
    CalcMaxDPTitleDescr: 'CalcMaxDPTitleDescr',
    Density: 'Density',
    Concentration: 'Concentration',
    SPEC_HEAT_CAP: 'SPEC_HEAT_CAP',
    RATED_CAP: 'RATED_CAP',
    TEMP_DIFF: 'TEMP_DIFF',
    airflowVolume: 'airflowVolume',
    TEMP_DIFF_AIR: 'TEMP_DIFF_AIR',
    TEMP_DIFF_WATER: 'TEMP_DIFF_WATER',
    DPMV: 'DPMV',
    DPVR: 'DPVR',
    pv: 'pv',
    outlet: 'outlet',
    inlet: 'inlet',
    methodA: 'methodA',
    methodB: 'methodB',
    CalcMassFlowTitle: 'CalcMassFlowTitle',
    CalcMassFlowTitleDescr: 'CalcMassFlowTitleDescr',
    massFlow: 'massFlow',
    CalcInletTitle: 'CalcInletTitle',
    CalcOutletTitle: 'CalcOutletTitle',
    CalcInletDescr: 'CalcInletDescr',
    CalcOutletDescr: 'CalcOutletDescr',
    userInputPageTitle: 'userInputPageTitle',
    homePageTitle: 'homePageTitle',
    homePageValvesTitle: 'homePageValvesTitle',
    recommended: 'recommended',
    conditionallyRecommended: 'conditionallyRecommended',
    selectValveType: 'selectValveType',
    RequestedFlow: 'RequestedFlow',
    SelectedValve: 'SelectedValve',
    SelectedActuator: 'SelectedActuator',
    SelectedAccessories: 'SelectedAccessories',
    apply: 'apply',
    clearAllFilters: 'clearAllFilters',
    modalFilterValvesLabel: 'modalFilterValvesLabel',
    modalFilterActuatorsLabel: 'modalFilterActuatorsLabel',
    checkoutPageTitle: 'checkoutPageTitle',
    checkoutValveAndActuatorTitle: 'checkoutValveAndActuatorTitle',
    checkoutAccessoriesTitle: 'checkoutAccessoriesTitle',
    checkoutTotal: 'checkoutTotal',
    checkoutSubTotal: 'checkoutSubTotal',
    accessoriesPageTitle: 'accessoriesPageTitle',
    accessoriesPageValvesTitle: 'accessoriesPageValvesTitle',
    accessoriesPageActuatorTitle: 'accessoriesPageActuatorTitle',
    actuatorsPageTitle: 'actuatorsPageTitle',
    valvesPageTitle: 'valvesPageTitle',
    kvs: 'kvs',
    dn: 'dn',
    stroke: 'stroke',
    ElectricalConnection: 'ElectricalConnection',
    SSFamily: 'SSFamily',
    _22_Fluid_temperature: '_22_Fluid_temperature',
    _25_Leakage_rate: '_25_Leakage_rate',
    _28_Differential_pressure_deltapmaxValue: '_28_Differential_pressure_deltapmaxValue',
    _32_Valve_body: '_32_Valve_body',
    _35_Differential_pressure_deltapmaxValue: '_35_Differential_pressure_deltapmaxValue',
    _37_Permissible_operating_pressure_ps: '_37_Permissible_operating_pressure_ps',
    _65_Torque_inlb: '_65_Torque_inlb',
    kvmax: 'kvmax',
    actuatingForce: 'actuatingForce',
    _121_Operating_range_Y: '_121_Operating_range_Y',
    cv: 'cv',
    _223_Actuating_force_lbf: '_223_Actuating_force_lbf',
    torque: 'torque',
    vnomgpm: 'vnomgpm',
    BodyPressureRating: 'BodyPressureRating',
    _461_Fluid_Temp_Range_water: '_461_Fluid_Temp_Range_water',
    kvssequence1: 'kvssequence1',
    _511_Kvs_Sequence_2: '_511_Kvs_Sequence_2',
    _660_Data_sheet_PDF: '_660_Data_sheet_PDF',
    _1003_Flow_characteristic: '_1003_Flow_characteristic',
    _2798_Valve_symbol: '_2798_Valve_symbol',
    vnomls: 'vnomls',
    _3581_Flow_characteristic: '_3581_Flow_characteristic',
    _6314_Installation_instructions: '_6314_Installation_instructions',
    Pattern: 'Pattern',
    Application: 'Application',
    _6667_ValveFamilyShort: '_6667_ValveFamilyShort',
    Fluid: 'Fluid',
    _6686_Leakage_rate: '_6686_Leakage_rate',
    _6827_Kvs_theor: '_6827_Kvs_theor',
    cvsequence1: 'cvsequence1',
    _6969_Seq_2_Cv: '_6969_Seq_2_Cv',
    vnomlh: 'vnomlh',
    Type: 'Type',
    CloseOffPressure: 'CloseOffPressure',
    userInputSequence1: 'userInputSequence1',
    userInputSequence2: 'userInputSequence2',
    deliveredMnt: 'deliveredMnt',
    deliveredUnmnt: 'deliveredUnmnt',
    missingDataMessage: 'missingDataMessage',
    pleaseContact: 'pleaseContact',
    FT_HEAD: 'FT_HEAD',
    Foot: 'Foot',
    somethingWrongModalTitle: 'somethingWrongModalTitle',
    somethingWrongModalSubtitle: 'somethingWrongModalSubtitle',
    somethingWrongModalMessage: 'somethingWrongModalMessage',
    checkoutMobile: 'checkoutMobile',
    selectedProductsTitle: 'selectedProductsTitle',
    selectedProductsDescription: 'selectedProductsDescription',
    selectMoreProducts: 'selectMoreProducts',
    deviceGridActionSort: 'deviceGridActionSort',
    exportExcel: 'exportExcel',
    exportExcelMobile: 'exportExcelMobile',
    exportExcelMaterial: 'exportExcelMaterial',
    exportExcelQuantity: 'exportExcelQuantity',
    Bar: 'bar',
    checkoutValvesBreadcrumbTitle: 'checkoutValvesBreadcrumbTitle',
    checkoutActuatorsBreadcrumbTitle: 'checkoutActuatorsBreadcrumbTitle',
    checkoutSensorsBreadcrumbTitle: 'checkoutSensorsBreadcrumbTitle',
    valvesHomePageFilterError: 'valvesHomePageFilterError',
    selectDevice: 'selectDevice',
    pipeConnectorLabel: 'pipeConnectorLabel',
    quantityShorthand: 'quantityShorthand',
    projectPageEmptyTitle: 'projectPageEmptyTitle',
    projectPageTitle: 'projectPageTitle',
    projectPageEmptyDescription: 'projectPageEmptyDescription',
    projectPageHomePage: 'projectPageHomePage',
    projectPageGoBack: 'projectPageGoBack',
    projectPageDownloadExcel: 'projectPageDownloadExcel',
    projectPageSelectAll: 'projectPageSelectAll',
    projectPageRenameSelection: 'projectPageRenameSelection',
    projectPageChangeSelection: 'projectPageChangeSelection',
    projectPageCopySelection: 'projectPageCopySelection',
    projectPageRemoveSelection: 'projectPageRemoveSelection',
    projectPageDeleteSelections: 'projectPageDeleteSelections',
    projectPageDragToPrevPage: 'projectPageDragToPrevPage',
    projectPageDragToNextPage: 'projectPageDragToNextPage',
    projectPageSelectionsCount: 'projectPageSelectionsCount',
    projectPageProductsCount: 'projectPageProductsCount',
    projectPageAddNewSelection: 'projectPageAddNewSelection',
    projectPageAddToCartSelection: 'projectPageAddToCartSelection',
    projectPageExportSelection: 'projectPageExportSelection',
    projectPageDuplicateSelection: 'projectPageDuplicateSelection',
    projectPageRenameLabel: 'projectPageRenameLabel',
    projectPageSelectionNameIsNotUniq: 'projectPageSelectionNameIsNotUniq',
    projectPageRenameModalHeader: 'projectPageRenameModalHeader',
    openProjectPageButton: 'openProjectPageButton',
    revitPluginInsertButton: 'revitPluginInsertButton',
    revitPluginDownloadXMLButton: 'revitPluginDownloadXMLButton',
    revitPluginVoltage: 'revitPluginVoltage',
    deviceGridActionFilter: 'deviceGridActionFilter',
    checkoutSelectValvePositionTitle: 'checkoutSelectValvePositionTitle',
    checkoutSelectValvePositionLMHeader: 'checkoutSelectValvePositionLMHeader',
    checkoutSelectValvePositionLMDescription: 'checkoutSelectValvePositionLMDescription',
    checkoutSelectValvePositionLRHeader: 'checkoutSelectValvePositionLRHeader',
    checkoutSelectValvePositionLRDescription: 'checkoutSelectValvePositionLRDescription',
    checkoutSelectValvePositionMRHeader: 'checkoutSelectValvePositionMRHeader',
    checkoutSelectValvePositionMRDescription: 'checkoutSelectValvePositionMRDescription',
    breadcrumbStepCounter: 'breadcrumbStepCounter',
};

export const BELIMO = 'Belimo';

export enum MandatoryFilter {
    ValveType = 'ValveType',
    Pattern = 'Pattern',
    Fluid = 'Fluid',
}

export const MandatoryAttributes: string[] = Object.values(MandatoryFilter);

export const NUMERIC_ATTRIBUTES = [
    '6943',
    '148',
    '3463',
    '6968',
    '15',
    '14',
    '28',
    '78',
    '3460',
    '7153',
    '510',
    '511',
    '528',
    '23',
    '880',
    '116',
    '147',
    '83',
    '230',
    '260',
    '118',
    '144',
    '8729',
    '8242',
    '2811',
    '8107',
    '8581',
    '16',
];

export const INTEGER_DIGITS = 5;
export const DECIMAL_DIGITS = 2;
export const ACTUATORS_DECIMAL_DIGITS = 1;
export const DOTS = '...';

export const PAGE_SIZE = 20;
export const MOBILE_WIDTH = 960;

export const FILTER_LABEL_QUERY_PARAM = 'fl';
export const ORDER_BY_NUMBER_QUERY_PARAM = '_o';
export const ORDER_BY_STRING_QUERY_PARAM = '_os';

export const SYMBOL_TO_UNIT_MAPPING: UnitMap.UnitMap = {
    mm: Units.Millimeter,
    m: Units.Meter,
    '"': Units.Inch,
    ft: Units.Foot,
    kW: Units.KiloWatt,
    'BTU/hr': Units.BtuPerHour,
    '°C': Units.Celsius,
    K: Units.Kelvin,
    '°F': Units.Fahrenheit,
    'm³/h': Units.CubicMeterPerHour,
    'l/s': Units.LiterPerSecond,
    'l/h': Units.LiterPerHour,
    GPM: Units.GallonsPerMinute,
    'kg/h': Units.KilogramPerHour,
    'lb/h': Units.PoundLbPerHour,
    'kJ/kgK': Units.KilojoulePerKilogramKelvin,
    'Btu/lb°F': BtuPerPoundPerFahrenheit,
    'kg/m³': Units.KilogramPerCubicMeter,
    'lb/ft³': Units.PoundPerCubicFoot,
    kPa: Units.KiloPascal,
    Pa: Units.Pascal,
    psi: Units.PoundForcePerSquareInch,
    'ft³/min': Units.CubicFeetPerMinute,
};

export const IMPERIAL_TO_METRIC_MAPPING = {
    [Units.GallonsPerMinute.name]: {
        metric: Units.CubicMeterPerHour,
        imperial: Units.GallonsPerMinute,
    },
    [Units.CubicMeterPerHour.name]: {
        metric: Units.CubicMeterPerHour,
        imperial: Units.GallonsPerMinute,
    },
    [Units.LiterPerSecond.name]: {
        metric: Units.LiterPerSecond,
        imperial: Units.GallonsPerMinute,
    },
    [Units.LiterPerHour.name]: {
        metric: Units.LiterPerHour,
        imperial: Units.GallonsPerMinute,
    },
    [Units.Millimeter.name]: {
        imperial: Units.Inch,
        metric: Units.Millimeter,
    },
    [Units.Meter.name]: {
        imperial: Units.Foot,
        metric: Units.Meter,
    },
    [Units.Inch.name]: {
        imperial: Units.Inch,
        metric: Units.Millimeter,
    },
    [Units.Foot.name]: {
        imperial: Units.Foot,
        metric: Units.Meter,
    },
};

export const OperationMode = 'OperationMode';

/* eslint-disable no-tabs */
/* eslint-disable max-len */
export const revitSharedParameterFile = `# This is a Revit shared parameter file.
# Do not edit manually.
*META	VERSION	MINVERSION
META	2	1
*GROUP	ID	NAME
GROUP	1	Belimo MagiCAD plugin
*PARAM	GUID	NAME	DATATYPE	DATACATEGORY	GROUP	VISIBLE	DESCRIPTION	USERMODIFIABLE	HIDEWHENNOVALUE
PARAM	dac80f1b-99b2-485c-85ee-115415d9175d	Belimo valve accessory 1	TEXT		1	1	Belimo valve accessory 1	1	0
PARAM	959eb730-10a1-4215-846e-3106163e603d	Belimo valve accessory 2	TEXT		1	1	Belimo valve accessory 2	1	0
PARAM	ca49608b-5a19-4a4b-a881-611368879d24	Belimo valve accessory 3	TEXT		1	1	Belimo valve accessory 3	1	0
PARAM	8ec809f2-0d75-460e-8646-af7e5430b65d	Belimo valve accessory 4	TEXT		1	1	Belimo valve accessory 4	1	0
PARAM	a6720669-0808-47cc-9542-cd93123bf0bf	Belimo actuator accessory 1	TEXT		1	1	Belimo actuator accessory 1	1	0
PARAM	f6eed268-61a2-49e8-8804-e46006a06711	Belimo actuator accessory 2	TEXT		1	1	Belimo actuator accessory 2	1	0
PARAM	bc3eee1d-723b-4c0c-8a60-4f0c7945d2c3	Belimo actuator accessory 3	TEXT		1	1	Belimo actuator accessory 3	1	0
PARAM	ad61317a-6f38-482d-9764-9501df58c913	Belimo actuator accessory 4	TEXT		1	1	Belimo actuator accessory 4	1	0`;

export const availableValveParameterIds = [
    'dac80f1b-99b2-485c-85ee-115415d9175d',
    '959eb730-10a1-4215-846e-3106163e603d',
    'ca49608b-5a19-4a4b-a881-611368879d24',
    '8ec809f2-0d75-460e-8646-af7e5430b65d',
];

export const availableActuatorParameterIds = [
    'a6720669-0808-47cc-9542-cd93123bf0bf',
    'f6eed268-61a2-49e8-8804-e46006a06711',
    'bc3eee1d-723b-4c0c-8a60-4f0c7945d2c3',
    'ad61317a-6f38-482d-9764-9501df58c913',
];
